import { render, staticRenderFns } from "./CustomFieldTemplate.vue?vue&type=template&id=b2d0c76c&"
import script from "./CustomFieldTemplate.vue?vue&type=script&lang=js&"
export * from "./CustomFieldTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports